import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: {},
    permissions:[],
    loading: false,
    error: null,
});

const actions = {
    async profileRead({ commit }, id) {
        try {
            commit('profileReadBegin');
            const response = await DataService.get(`/users/${id}`);
            commit('profileReadSuccess', response.data.data);
        } catch (err) {
            commit('profileReadErr', err);
        }
    },

    async setPassword({ commit }, data) {
        try {
            commit('setPasswordBegin');
            const response = await DataService.post(`/set-password`, data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            if (err.message !== undefined) {

                notification.error({
                    message: err.message,
                    placement: 'topRight'
                });
            }
        }
    },

    async socialProfileAdd({ commit }, data) {
        try {
            commit('socialProfileAddBegin');
            const response = await DataService.post(`/user-preferences`, data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            if (err.message !== undefined) {

                notification.error({
                    message: err.message,
                    placement: 'topRight'
                });
            }
        }
    },

    async socialProfileUpdate({ commit }, data) {
        try {
            commit('socialProfileUpdateBegin');
            const response = await DataService.patch(`/user-preferences/${data.preferenceId}`, data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            if (err.message !== undefined) {

                notification.error({
                    message: err.message,
                    placement: 'topRight'
                });
            }
        }
    },

    async profileUpdate({ commit }, data) {
        try {
            commit('userUpdateBegin');
            const response = await DataService.patch(`/users/${data.id}`, data);
            commit('userUpdateSuccess');

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            if (err.message !== undefined) {

                notification.error({
                    message: err.message,
                    placement: 'topRight'
                });
            }
        }
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};